export default __webpack_public_path__ + "static/bows-89111c4235965172924ba0f23ae5aa95.png";